// functions/resetPassword.js
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

export default function resetPassword(email) {
  const auth = getAuth();
  return sendPasswordResetEmail(auth, email);
}
